import { IAppState } from '../../common/state';

export function getNewbuildingSeoTitle({ results }: IAppState): string | undefined {
  const { pathname } = new URL(results.fullUrl);

  return (pathname && !pathname.startsWith('/cat.php') && results.seo.h1) || undefined;
}
